import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import SkillAnalyticsDetail from "../components/analytics/SkillAnalyticsDetail";
import EvaluationAnalyticsDetail from "../components/analytics/EvaluationAnalyticsDetail";
import SkillMapping from "../components/analytics/SkillMapping";
import EvaluationMapping from "../components/analytics/EvaluationMapping";
import QuestionMapping from "../components/analytics/QuestionMapping";

type StatisticsRouterProps = RouteComponentProps;

const StatisticsRouter: React.FC<StatisticsRouterProps> = ({ match }) => {
  return (
    <Switch>
      <Route
        path={`${match.path}/skill-mapping`}
        exact
        component={SkillMapping}
      />
      <Route
        path={`${match.path}/evaluation-mapping`}
        exact
        component={EvaluationMapping}
      />
      <Route
        path={`${match.path}/question-mapping`}
        exact
        component={QuestionMapping}
      />
      <Route
        path={`${match.path}/skills/:id`}
        exact
        component={SkillAnalyticsDetail}
      />
      <Route
        path={`${match.path}/evaluations/:digest`}
        exact
        component={EvaluationAnalyticsDetail}
      />
    </Switch>
  );
};

export default StatisticsRouter;
